import { supportsVirtualKeyboardApi } from './supportsVirtualKeyboardApi';

/**
 * Returns the height of the virtual keyboard if it is visible, otherwise `0`.
 *
 * @returns the height of the virtual keyboard in pixels.
 */
export function getVirtualKeyboardHeight(): number {
  if (supportsVirtualKeyboardApi(navigator)) {
    // Checking for support of virtual keyboard API to get the actual height:
    //
    // See: https://developer.mozilla.org/en-US/docs/Web/API/VirtualKeyboard_API
    // See: https://developer.chrome.com/docs/web-platform/virtual-keyboard
    const { height } = navigator.virtualKeyboard.boundingRect;
    if (height > 0) {
      return height;
    }
  }

  const { visualViewport } = window;
  if (!visualViewport) {
    return 0;
  }

  const documentHeight = document.body.clientHeight;
  const viewportHeight = visualViewport.height;
  return Math.abs(viewportHeight - documentHeight);
}
